export const list_of_classes = [
  {
    class_id: 1,
    date: "2021-09-07",
    duration: "1",
    intensityLevel: "low",
    location: "location 1",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 2,
    date: "2021-08-30",
    duration: "2",
    intensityLevel: "low",
    location: "location 2",
    maxClassSize: "55",
    name: "massy",
    registeredAttendees: 0,
    startTime: "16:40",
    type: "type a",
  },
  {
    class_id: 3,
    date: "2021-09-07",
    duration: "3",
    intensityLevel: "low",
    location: "location 3",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 4,
    date: "2021-09-07",
    duration: "4",
    intensityLevel: "low",
    location: "location 4",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 5,
    date: "2021-09-07",
    duration: "5",
    intensityLevel: "low",
    location: "location 5",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 10,
    date: "2021-09-07",
    duration: "10",
    intensityLevel: "low",
    location: "location 10",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 20,
    date: "2021-08-30",
    duration: "20",
    intensityLevel: "low",
    location: "location 20",
    maxClassSize: "55",
    name: "massy",
    registeredAttendees: 0,
    startTime: "16:40",
    type: "type a",
  },
  {
    class_id: 30,
    date: "2021-09-07",
    duration: "30",
    intensityLevel: "low",
    location: "location 30",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 40,
    date: "2021-09-07",
    duration: "40",
    intensityLevel: "low",
    location: "location 40",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
  {
    class_id: 50,
    date: "2021-09-07",
    duration: "50",
    intensityLevel: "low",
    location: "location 50",
    maxClassSize: "23",
    name: "tom",
    registeredAttendees: 0,
    startTime: "04:35",
    type: "type b",
  },
];
